<template>
<div id="app">
  <b-navbar toggleable="lg" variant="dark" type="dark" id="header-nav">
    <b-navbar-brand>
      <router-link to="/">
        <img class="sci-fund-logo" src="./assets/sci-fund-logo.png" >
      </router-link>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>

    <b-navbar-nav class="ccenter">
      <b-nav-item v-if="authenticated" to="/">
          Search
      </b-nav-item>


      <b-nav-item v-if="authenticated" to="/infographics">
          <v-icon name="trending-up" class="vicon"></v-icon> Infographics
      </b-nav-item>


      <b-nav-item v-if="authenticated" to="/savedsearches">
          <v-icon name="bookmark" class="vicon"></v-icon> Saved
      </b-nav-item>

      <b-nav-item v-if="authenticated" to="/profile">
          <v-icon name="user" class="vicon"></v-icon> My profile
      </b-nav-item>

      <b-nav-item to="/help">
        <v-icon name="info" class="vicon"></v-icon> Info/Help
      </b-nav-item>

      <b-nav-item v-if="!authenticated" to="/login">
          <v-icon name="user" class="vicon"></v-icon> {{$t('general.login')}}
      </b-nav-item>

      <b-nav-item v-if="authenticated" v-on:click.prevent="logout">
         {{$t('general.logout')}}
      </b-nav-item>

    </b-navbar-nav>

    <div class="logo">
      <span><img src="./assets/contexity-logo-26.png" ><br>
      <!-- <span class="byline">Smart Context Search Horizon Europe</span>--></span>
    </div>
    </b-collapse>
  </b-navbar>

  <div class="main-page-content">
  <router-view/>
  </div>
  <PageFooter></PageFooter>
  <FutureFeatures></FutureFeatures>
</div>

</template>

<script>
import PageFooter from '@/components/PageFooter'
import FutureFeatures from '@/components/FutureFeatures'

export default {
  name: 'App',
  components: {
    FutureFeatures,
    PageFooter
  },
  created: function () {
  },
  computed: {
    authenticated () {
      return this.$store.state.authenticated;
    }
  },
  methods: {
    logout () {
      this.$store.commit('removeAuthToken');
      this.$router.push('/login');
    }
  }
}
</script>

<style lang="scss">
  @import '@/styles/bootstrap_variables.scss';
  @import '~bootstrap/scss/bootstrap.scss';
  @import '@/styles/app.scss';

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .sci-fund {
    color: #fff;
    text-decoration: none;
    font-size: 1.8em;
    font-weight: 500;
    font-family: "Maven Pro";
    vertical-align: sub;
  }
  .sci-fund-logo {
    margin: 0.2em 0.2em 0.2em 0.2em;
    max-height:60px;
  }
  .zlogo {
    background-color: #fff;
  }
  .logo {
    float:right;
    text-align:right;
  }

  .icon-link {
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 10px;
  }
  .header {
    position: relative;
    background-image: url('./assets/knowledge-graph.png');
    height: 50px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .byline {
    font-family: "Maven Pro";
    color: #fff;
    font-size: 18px;
  }
  .ccenter {
    margin:auto;
  }

  .navbar .router-link-exact-active {
    color: #ffffff !important;
    font-weight: 700;
  }
  #header-nav li.nav-item {
    font-size: 1.2rem;
    margin-right: 1.2rem;
  }
  .main-page-content {
    min-height: 640px;
  }
</style>
